import { Component, OnInit, Input } from '@angular/core'
import { GroupInfo } from '@app/core/_models'
import { UtilsService } from '@app/core/_services/utils.service'

@Component({
    selector: 'app-profile-info-groups',
    templateUrl: './profile-info-groups.component.html',
    styleUrls: ['./profile-info-groups.component.scss'],
    standalone: false,
})
export class ProfileInfoGroupsComponent implements OnInit {
    @Input() groupInfo: GroupInfo[] = []
    @Input() timeZone: string
    @Input() adminView: boolean

    constructor(public utilsService: UtilsService) {}

    ngOnInit() {}

    leaveGroup(param) {
        // Do nothing
    }

    acceptInvite(param) {
        // Do nothing
    }

    declineInvite(param) {
        // Do notning
    }
}
